import { yieldForBridgeInteractivePriority } from '../../files/browser/in-flight.js';
import {
  withCodeNavCacheSqlite,
  withCodeNavCacheSqliteSync,
} from '../../sqlite/code-nav-cache/database.js';
import { FILE_INDEX_INSERT_BUFFER } from './file-index-persist-constants.js';
import { assertFileIndexPersistNotShutdown } from './file-index-persist-shutdown.js';
import {
  clearFileIndexChildPaths,
  insertFileIndexChildPathBatch,
} from './file-index-persist-transaction.js';

/**
 * Replace `file_index_child_path` rows for this parent path in one transaction.
 * Must only run while holding {@link withFileIndexSqliteLock}.
 */
export function persistFileIndexPaths(resolved: string, paths: readonly string[]): number {
  withCodeNavCacheSqliteSync((db) => clearFileIndexChildPaths(db, resolved));
  let pathCount = 0;
  for (let offset = 0; offset < paths.length; offset += FILE_INDEX_INSERT_BUFFER) {
    assertFileIndexPersistNotShutdown();
    const batch = paths.slice(offset, offset + FILE_INDEX_INSERT_BUFFER);
    pathCount += withCodeNavCacheSqliteSync((db) => insertFileIndexChildPathBatch(db, resolved, batch));
  }
  return pathCount;
}

/**
 * Like {@link persistFileIndexPaths} but yields during large inserts so bridge I/O stays responsive.
 * Must only run while holding {@link withFileIndexSqliteLock}.
 */
export async function persistFileIndexPathsAsync(resolved: string, paths: readonly string[]): Promise<number> {
  await withCodeNavCacheSqlite((db) => clearFileIndexChildPaths(db, resolved));
  let pathCount = 0;
  for (let offset = 0; offset < paths.length; offset += FILE_INDEX_INSERT_BUFFER) {
    assertFileIndexPersistNotShutdown();
    const batch = paths.slice(offset, offset + FILE_INDEX_INSERT_BUFFER);
    pathCount += await withCodeNavCacheSqlite((db) => insertFileIndexChildPathBatch(db, resolved, batch));
    await yieldForBridgeInteractivePriority();
  }
  return pathCount;
}
